export default {
      id: "go-to-usage",
      viewBox: "0 0 30 30",
      url: "/assets/" + "icons.svg#go-to",
      toString: function () {
        return this.url;
      }
    }